// extracted by mini-css-extract-plugin
export default {"bubble":"_7880e768","icon":"_16c24a5d","pinterest":"_f6c54aa0","facebook":"_38eb4dbe"};